<template>
  <ul
    v-if="items.length > 0"
    :class="[
      'hierarchical-list',
      level > 0 && ['list', 'child'],
      ['list', `lvl${level}`],
    ]"
  >
    <li
      v-for="item in items"
      :key="item.value"
      :class="[
        'item',
        item.data && item.data.length > 0 && ['item', 'parent'],
        item.isRefined && ['item', 'selected'],
      ]"
    >
      <a
        :href="createURL(item.value)"
        :class="['link', item.isRefined && ['link', 'font-weight-bold']]"
        @click.prevent="refine(item.value)"
      >
        <b-form-checkbox
          :checked="item.isRefined"
        >
          {{ item.label }}
          <span class="badge badge-pill badge-primary">{{ item.count }}</span>
        </b-form-checkbox>
      </a>

      <styled-hierarchical-menu-list
        v-if="item.data"
        :items="item.data"
        :level="level + 1"
        :refine="refine"
        :createURL="createURL"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'StyledHierarchicalMenuList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    refine: {
      type: Function,
      required: true,
    },
    createURL: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
  .hierarchical-list {
    list-style: none;
    padding-left: 0;
  }

  .hierarchical-list.child {
    padding-left: 1rem;
  }
</style>
